// extracted by mini-css-extract-plugin
export default {"payment":"Payment_payment__GcTuQ","title":"Payment_title__XntFT"};